module.exports = __webpack_public_path__ + "static/media/BrowseServerFolders.69778b11.scss";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio-shared/view/Utilities/BrowseServerFolders.scss
// module id = 764
// module chunks = 1